import type { PublicMediaAsset } from '~/modules/public/purchase/domain/public-purchase.types'

const WIDTHS = [320, 640, 960, 1440, 1920] as const
const PUBLIC_MEDIA_PATH = /^\/api\/bff\/public\/media\/assets\/[0-9a-f-]+\/content$/iu
export const HERO_IMAGE_SIZES = '(min-width: 1840px) 1792px, calc(100vw - 48px)'
export const POSTER_IMAGE_SIZES = '(min-width: 1440px) 440px, (min-width: 768px) 26vw, 80vw'
export const CARD_IMAGE_SIZES = '(min-width: 1200px) 400px, (min-width: 768px) 45vw, 90vw'
export const FACET_IMAGE_SIZES = '(min-width: 1800px) 320px, (min-width: 1200px) 285px, 250px'

type PublicImage = Pick<PublicMediaAsset, 'contentPath'>

function renditionSrcset(src: string, query: string) {
  return WIDTHS.map(width => `${src}?width=${width}${query} ${width}w`).join(', ')
}

/** WebP `<img>` attributes: the universal fallback of every public image. */
export function publicImageAttributes(image: PublicImage, sizes: string) {
  const src = image.contentPath
  if (!PUBLIC_MEDIA_PATH.test(src)) return { src }
  return {
    src: `${src}?width=960`,
    srcset: renditionSrcset(src, ''),
    sizes
  }
}

/** AVIF `<source>` for the same renditions; null when the asset has no responsive endpoint. */
export function publicImageAvifSource(image: PublicImage, sizes: string) {
  const src = image.contentPath
  if (!PUBLIC_MEDIA_PATH.test(src)) return null
  return {
    type: 'image/avif',
    src: `${src}?width=960&format=avif`,
    srcset: renditionSrcset(src, '&format=avif'),
    sizes
  }
}
